"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergePortfolioData = exports.addDefaultPortfolioFlag = void 0;
var tslib_1 = require("tslib");
var getOr_1 = tslib_1.__importDefault(require("lodash/fp/getOr"));
var aggregatePortfolios = function (portfolios, portfolioGroupings, selectedOption, isClosedToggle) {
    var portfoliosToShow = isClosedToggle
        ? portfolios
        : portfolios.filter(function (g) { return g.IsActive; });
    if (selectedOption === 'Flat List') {
        portfoliosToShow.forEach(function (portfolio) {
            var groupID = getOr_1.default(0, 'GroupID', portfolio);
            var indexOfGroup = portfolioGroupings.findIndex(function (grouping) { return grouping.ID === groupID; });
            portfolioGroupings[indexOfGroup].children.push(portfolio);
        });
        return portfolioGroupings;
    }
    if (selectedOption === 'Custom Grouping') {
        portfoliosToShow.forEach(function (portfolio) {
            var groupID = getOr_1.default(0, 'GroupID', portfolio);
            var indexOfGroup = portfolioGroupings.findIndex(function (grouping) { return grouping.ID === groupID; });
            portfolioGroupings[indexOfGroup].children.push(portfolio);
        });
        return portfolioGroupings;
    }
    if (selectedOption === 'True NAV') {
        var standardGroup_1 = portfolioGroupings.find(function (g) { return g.ID === 5; });
        var trueNavGroup_1 = portfolioGroupings.find(function (g) { return g.ID === 6; });
        portfoliosToShow.forEach(function (portfolio) {
            var _a;
            var isStandard = ((_a = portfolio.TrueNAVBasePortID) !== null && _a !== void 0 ? _a : 1) === 0;
            if (isStandard) {
                standardGroup_1 === null || standardGroup_1 === void 0 ? void 0 : standardGroup_1.children.push(portfolio);
            }
            else {
                trueNavGroup_1 === null || trueNavGroup_1 === void 0 ? void 0 : trueNavGroup_1.children.push(portfolio);
            }
        });
        return portfolioGroupings;
    }
    return portfolioGroupings;
};
exports.addDefaultPortfolioFlag = function (portfolios, defaultPortfolioId) {
    if (!defaultPortfolioId) {
        return portfolios;
    }
    return portfolios.map(function (portfolio) {
        return tslib_1.__assign(tslib_1.__assign({}, portfolio), { isDefault: portfolio.ID === defaultPortfolioId });
    });
};
exports.mergePortfolioData = function (portfoliosToShow, portfolioGroups, selectedOption, isClosedToggle) {
    var defaultGroup = {
        ID: 0,
        Name: 'Default',
        children: [],
    };
    var structuredGroups = portfolioGroups.map(function (group) {
        var groupData = {
            ID: getOr_1.default(0, 'ID', group),
            Name: getOr_1.default('Unknown', 'Name', group),
            children: [],
        };
        return groupData;
    });
    var standardGroupData = {
        ID: 5,
        Name: 'Standard',
        children: [],
    };
    var trueNavGroupData = {
        ID: 6,
        Name: 'True NAV',
        children: [],
    };
    var combineGroupings = [standardGroupData, trueNavGroupData];
    var portfolioGroupings = tslib_1.__spreadArrays([
        defaultGroup
    ], structuredGroups, combineGroupings);
    var portfolioData = aggregatePortfolios(portfoliosToShow, portfolioGroupings, selectedOption, isClosedToggle);
    return portfolioData;
};
